"use client";

// Both icons are always in the markup, identical on server and client —
// CSS (the `dark:` variant) decides which one is visible, so there's
// nothing here that depends on a client-only value at render time. That
// matters: reading document.documentElement at render time (e.g. to pick
// an icon) would render "light" on the server (no `document`) and
// whatever the inline theme-init script already set on the client,
// causing a hydration mismatch on every load where the two disagree.
export function ThemeToggle() {
  function toggle() {
    const next = !document.documentElement.classList.contains("dark");
    document.documentElement.classList.toggle("dark", next);
    try {
      localStorage.setItem("theme", next ? "dark" : "light");
    } catch {
      // Storage can be unavailable (private browsing, blocked cookies) —
      // the toggle still works for the current page load either way.
    }
  }

  return (
    <button
      onClick={toggle}
      aria-label="Toggle color theme"
      className="rounded-md p-1.5 text-black/60 hover:bg-black/5 hover:text-black dark:text-white/60 dark:hover:bg-white/10 dark:hover:text-white"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="hidden h-4 w-4 dark:block"
      >
        <circle cx="12" cy="12" r="4" />
        <path
          strokeLinecap="round"
          d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
        />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="block h-4 w-4 dark:hidden">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
    </button>
  );
}
